import React, { useState } from 'react';
import './MeetingClipsModal.scss';
import Rodal from '../../../../../components/Rodal/Rodal';
import { ModalHeader, ModalBody } from 'reactstrap';
import EngagementVideoClipsList from '../../../../ConnectMarketplaceDashboard/EngagementMeetings/EngagementVideoClipsList/EngagementVideoClipsList';
import { VideoClip } from '../../../../PracticeManagementGroups/Conferences/SaveVideoClipPopup/SaveVideoClipPopup';
import VideoPlayerPopup from '../../../../VideoPlayerPopup/VideoPlayerPopup';
import { CalendarObject } from '../../../../../slices/marketplace/meetings/models/calendar-object.model';

interface MeetingClipsModalProps {
    isVisible: boolean;
    onClose: () => void;
    selectedEvent?: CalendarObject;
    loadingTrigger: number;
    onClipSave: () => void;
    isReadOnlyMode?: boolean;
}

const MeetingClipsModal = (props: MeetingClipsModalProps) => {
    const [selectedClip, setSelectedClip] = useState<VideoClip>();
    const [videoSource, setVideoSource] = useState<string>();
    const [videoIsHls, setVideoIsHls] = useState<boolean>(false);

    const handleVideoClipOpen = (clip: VideoClip, source: string, isHls: boolean) => {
        setSelectedClip(clip);
        setVideoSource(source);
        setVideoIsHls(isHls);
    };

    const handleVideoClipClose = () => {
        setSelectedClip(undefined);
        setVideoSource(undefined);
        setVideoIsHls(false);
    };

    if (!props.selectedEvent) {
        return null;
    }

    return (
        <div className="meeting-clips-modal">
            <Rodal
                width={1200}
                height={700}
                visible={props.isVisible && !selectedClip}
                animation={'slideDown'}
                onClose={props.onClose}
                center>
                <ModalHeader>
                    Meeting Clips - {props.selectedEvent.name}
                </ModalHeader>
                <ModalBody className="meeting-clips-modal-body">
                    <div className="clips-sections">
                        <div className="conferences">
                            <div className="header">
                                <label className="title">My Clips</label>
                            </div>
                            <EngagementVideoClipsList
                                engagementId={props.selectedEvent.engagementId || 0}
                                areMyClipsOnlyVisible={true}
                                loadingTrigger={props.loadingTrigger}
                                onClipSave={props.onClipSave}
                                isReadOnlyMode={props.isReadOnlyMode}
                                customApiEndpoint={`/api/Marketplace/MarketplaceMeetings/clips/event/${props.selectedEvent.id}`}
                                onVideoClipOpen={handleVideoClipOpen}
                            />
                        </div>
                        <div className="conferences">
                            <div className="header">
                                <label className="title">Shared Clips</label>
                            </div>
                            <EngagementVideoClipsList
                                engagementId={props.selectedEvent.engagementId || 0}
                                areMyClipsOnlyVisible={false}
                                loadingTrigger={props.loadingTrigger}
                                onClipSave={props.onClipSave}
                                isReadOnlyMode={props.isReadOnlyMode}
                                customApiEndpoint={`/api/Marketplace/MarketplaceMeetings/clips/shared/event/${props.selectedEvent.id}`}
                                onVideoClipOpen={handleVideoClipOpen}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Rodal>
            {selectedClip && videoSource && (
                <VideoPlayerPopup
                    title={selectedClip.title}
                    src={videoSource}
                    isHls={videoIsHls}
                    onClose={handleVideoClipClose}
                    isRecordingEnabled={false}
                    startTimeSeconds={selectedClip.timeStartSeconds}
                    endTimeSeconds={selectedClip.timeEndSeconds}
                />
            )}
        </div>
    );
};

export default MeetingClipsModal;